export default "__VITE_ASSET__65423ddf__"